import React from "react";

export default function SecaoCard({ titulo, children, centralizarConteudo = true }) {
  return (
    <div
      style={{
        width: "100%",
        border: "1px solid #E8E8E8",
        borderRadius: "12px",
        padding: "24px 28px",
        backgroundColor: "#FFFFFF",
        boxSizing: "border-box",
        boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
      }}
    >
      <h3
        style={{
          margin: "0 0 16px 0",
          paddingBottom: "12px",
          borderBottom: "1px solid #EEEEEE",
          fontSize: "12px",
          fontWeight: 500,
          letterSpacing: "0.08em",
          textTransform: "uppercase",
          color: "#999999",
        }}
      >
        {titulo}
      </h3>
      <div
        style={
          centralizarConteudo
            ? { width: "100%", maxWidth: 900, margin: "0 auto" }
            : { width: "100%" }
        }
      >
        {children}
      </div>
    </div>
  );
}
